import * as React from 'react';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

export function CactusLoadingPage() {
    return (
        <EmptyStateSmall
            title=''
            subtitle='Hold tight, we’re fetching your data…'
            icon={
                <div style={{width: 80}}>
                    <Illustration src='cactus-empty-state' width='100%' height='100%' />
                </div>
            }
        />
    );
}
